import { RawCompanyData } from '@company/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateWithCompany } from '../company-state';
import { getCompanyState } from './feature.selector';

export const getSavedCompany: MemoizedSelector<StateWithCompany, RawCompanyData> = createSelector(
  getCompanyState,
  (state) => state?.saved,
);
